import { FiltroConsultaReciboDetalle } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import { DetalleNovedad, DatosCambioEstado } from "../modelo/ConsultaNovedadesDetalle";

export const CONSULTAR_NOVEDADES_DETALLE = "CONSULTAR_NOVEDADES_DETALLE";
export const CONSULTAR_NOVEDADES_DETALLE_XLS = "CONSULTAR_NOVEDADES_DETALLE_XLS";
export const EXITO_CONSULTA_NOVEDADES_DETALLE = "EXITO_CONSULTA_NOVEDADES_DETALLE";
export const EXITO_CONSULTA_NOVEDADES_DETALLE_XLS = "EXITO_CONSULTA_NOVEDADES_DETALLE_XLS";
export const ERROR_CONSULTA_NOVEDADES_DETALLE = "ERROR_CONSULTA_NOVEDADES_DETALLE";
export const ERROR_CONSULTA_NOVEDADES_DETALLE_XLS = "ERROR_CONSULTA_NOVEDADES_DETALLE_XLS";
export const LIMPIAR_MENSAJES_ESTADO = "LIMPIAR_MENSAJES_ESTADO";
export const ENVIAR_CAMBIO_ESTADO = "ENVIAR_CAMBIO_ESTADO";
export const EXITO_ENVIAR_CAMBIO_ESTADO = "EXITO_ENVIAR_CAMBIO_ESTADO";
export const ERROR_ENVIAR_CAMBIO_ESTADO = "ERROR_ENVIAR_CAMBIO_ESTADO";


export const consultarNovedadesDetalle = (filtro: FiltroConsultaReciboDetalle) => ({ type: CONSULTAR_NOVEDADES_DETALLE, filtro });
export const exitoConsultaNovedadesDetalle = (datosEntidad: Array<DetalleNovedad>, paginas: number, totalDatos: number) => ({
    type: EXITO_CONSULTA_NOVEDADES_DETALLE, datosEntidad, paginas, totalDatos
});
export const errorConsultaNovedadesDetalle = () => ({ type: ERROR_CONSULTA_NOVEDADES_DETALLE });

export const consultarNovedadesDetalleXLS = (filtro: FiltroConsultaReciboDetalle) => ({ type: CONSULTAR_NOVEDADES_DETALLE_XLS, filtro });
export const exitoConsultaNovedadesDetalleXLS = () => ({ type: EXITO_CONSULTA_NOVEDADES_DETALLE_XLS });
export const errorConsultaNovedadesDetalleXLS = () => ({ type: ERROR_CONSULTA_NOVEDADES_DETALLE_XLS });

export const limpiarMensajesEstado = () => ({ type: LIMPIAR_MENSAJES_ESTADO });

export const enviarCambioEstado = (datosEnvio: DatosCambioEstado) => ({ type: ENVIAR_CAMBIO_ESTADO, datosEnvio });
export const exitoEnviarCambioEstado = () => ({ type: EXITO_ENVIAR_CAMBIO_ESTADO });
export const errorEnviarCambioEstado = () => ({ type: ERROR_ENVIAR_CAMBIO_ESTADO });



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_detalle/modulos/reciboNovedadesDetalleActions.ts